import { Box, Stack, Typography, styled, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ButtonsPrimary } from '../ComponentApp/buttoms/ButtonsXcala';
import SuccessStep from '../UI/successStep';
import ConditionsPassword from './ConditionsPassword';
import NewPasswordInput from './NewPasswordInput';

const WrapperSection = styled(Stack)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));
const TitleContainer = styled(Stack)(({ theme }) => ({
  width: '80%',
  justifyContent: 'center',
  height: '70px',
  textAlign: 'center',
  marginTop: '-46px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
  [theme.breakpoints.down('md')]: {
    width: '100%',
    textAlign: 'center',
  },
}));
export const ImageContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.up('md')]: {
    width: '50%',
  },
  boxSizing: 'border-box',
  height: '120px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));
export const PasswordGif = styled('img')(({ theme }) => ({
  objectFit: 'cover',
  position: 'absolute',
  width: '120px',
  height: '120px',
  [theme.breakpoints.up('md')]: {
    width: '150px',
    height: '150px',
  },
}));
export const InputContainer = styled(Box)(({ theme }) => ({
  width: '90%',
  marginTop: '36px',
  [theme.breakpoints.up('md')]: {
    width: '50%',
  },
}));
const TitleText = styled(Typography)(({ theme }) => ({
  marginLeft: '20px',
  fontWeight: theme.typography.signInWelcome.fontWeight,
  color: theme.palette.primary.main,
  fontSize: theme.typography.h1.fontSize,
  [theme.breakpoints.down('md')]: {
    fontSize: theme.typography.profile.fontSize,
    marginLeft: '0px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.titleText.fontSize,
    marginLeft: '0px',
  },
}));

export const PasswordChangeContainer = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  borderTop: '1px solid rgba(170, 167, 167, 0.25)',
  borderRadius: '8px',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-evenly',
  padding: '16px 12px',
  boxSizing: 'border-box',
  width: '100%',
  maxWidth: 800,
  margin: '0px auto',
  top: '16px',
  marginBottom: '24px',
}));
export const SuccessContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '90%',
  flexDirection: 'column',
  alignItems: 'center',
}));
export const SubmitButtonContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  padding: '0px',
  [theme.breakpoints.down('md')]: {
    padding: '10px',
    width: '60%',
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));
const StyledLink = styled('button')(({ theme }) => ({
  color: theme.palette.primary.main,
  background: 'none',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  fontFamily: 'inherit',
  fontSize: 'inherit',
  textDecoration: 'none',
  '&:hover': {
    color: theme.palette.primary.dark,
  },
}));

const StyledBackLink = ({ children }) => {
  const navigate = useNavigate();

  return <StyledLink onClick={() => navigate(-1)}>{children}</StyledLink>;
};

const CardChangePassword = ({
  mustContainData,
  step,
  password,
  validatePassword,
  currentPassword,
  confirmPassword,
  loadingChangePassword,
  handleNewPassword,
  handleCurretPassword,
  handleConfirmPassword,
}) => {
  const isCurrentPassword = currentPassword.length > 0;
  const isDisableStepTwo = mustContainData.every(item => item[1] || item[2]);

  return (
    <>
      <WrapperSection>
        <TitleContainer>
          <TitleText>Cambiar contraseña</TitleText>
        </TitleContainer>
        <PasswordChangeContainer
          minHeight={step === 1 || step === 3 ? '496px' : { md: '580px', xs: '650px' }}>
          {step === 1 ? (
            <>
              <ImageContainer>
                <PasswordGif src='/assets/images/changepassword-gif.gif' />
              </ImageContainer>
              <InputContainer>
                <NewPasswordInput
                  title={'Contraseña actual'}
                  password={currentPassword}
                  validatePassword={handleCurretPassword}
                />
              </InputContainer>
            </>
          ) : step === 2 ? (
            <>
              <ConditionsPassword
                password={password}
                confirmPassword={confirmPassword}
                mustContainData={mustContainData}
                validatePassword={validatePassword}
                handleConfirmPassword={handleConfirmPassword}
              />
            </>
          ) : step === 3 ? (
            <>
              <SuccessContainer>
                <SuccessStep
                  Success_heading=' Perfecto!'
                  Success_subheading='Ahora puedes ingresar a tu cuenta de Xcala con tu nueva contraseña .'
                  Success_btn='Volver al inicio'
                  href='/'
                  setBack={null}
                />
              </SuccessContainer>
            </>
          ) : null}
          {step === 1 || step === 2 ? (
            <SubmitButtonContainer
              marginTop={step === 2 ? '-10px' : '20px'}
              marginBottom={step === 2 ? '20px' : '0px'}>
              <ButtonsPrimary
                name='Cambiar contraseña'
                onClick={handleNewPassword}
                disabled={
                  step === 2
                    ? !isDisableStepTwo
                    : null || loadingChangePassword || !isCurrentPassword
                }
                sx={{ width: { md: '50%', xs: '100%' } }}
              />
            </SubmitButtonContainer>
          ) : null}
          {step === 1 ? (
            <Stack marginTop={'-4px'}>
              <StyledBackLink>No por ahora</StyledBackLink>
            </Stack>
          ) : null}
        </PasswordChangeContainer>
      </WrapperSection>
    </>
  );
};

export default CardChangePassword;
